import React from 'react';
import { ListViewProps } from './list-view.types';
import { RootTagName } from '../../table-component/table-component.props';
import { PAGES } from '../../../common/enums';
import TableComponent from '../../table-component';
import useListViewColumns from '../hooks/use-list-view-columns';
import useCheckPage from '../../../hooks/use-check-page';
import { changeSort } from '../../../actions/app_action';
import { useDispatch } from 'react-redux';
import { AnyObject } from '../../../common/interfaces';
import { Sort } from '../vehicle-offers-list-component.props';
import { useTypedSelector } from '../../../hooks/use-typed-selector';

const ListView = ({ isFetching, items, tableParams, reloadList }: ListViewProps) => {
  const dispatch = useDispatch();
  const sort: Sort = useTypedSelector((state: AnyObject): Sort => state['app'].smartTable.sort);
  const columns = useListViewColumns(reloadList);
  const { isEmployeeConfigurationsPage, isNewEmployeeConfigurationsPage } = useCheckPage();

  const rowsForTable = items.map(item => ({
    ...item,
    globalFaConfigurationType: item.globalFaConfigurationType?.label,
    uds_listenpreis: item.uds_listenpreis?.label,
    freigeber: item.freigeber?.name
  }));

  const sortHandler = (sortName: any) => {
    const sortParam = {
      predicate: sortName,
      reverse: sortName === sort.predicate ? !sort.reverse : true
    };
    dispatch(changeSort(sortParam));
  };

  return (
    <TableComponent
      loading={isFetching}
      columns={columns}
      rows={rowsForTable}
      minWidth={1720}
      rootTag={{
        name: RootTagName.Link,
        to: `${
          isEmployeeConfigurationsPage
            ? PAGES.EMPLOYEE_CONFIGURATION_DETAILS
            : isNewEmployeeConfigurationsPage
            ? PAGES.REFERENCE_VEHICLES_DETAILS
            : PAGES.CONFIGURATION_DETAILS
        }?id=`,
        propName: 'uds_fahrzeugangeboteid'
      }}
      scrollXEnable
      widthInPercent={100}
      sort={sortHandler}
      sortParams={tableParams.sort}
    />
  );
};

export default ListView;
